module.exports = __webpack_public_path__ + "static/img/2735_phase_function_Paper_PointsHejduk_Prediction.9af7df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2735_phase_function_Paper_PointsHejduk_Prediction.png
// module id = l88s
// module chunks = 0